import { PsOriginBase } from './PsOriginBase';

export class PsWorker extends PsOriginBase {

    _id; // number
    _name; // string
    _lastName; // string
    _company; // PsCompany

    constructor(
        id,
        name,
        lastName,
    ) {
        super();
        this._id = id;
        this._name = name;
        this._lastName = lastName;
    }

    static fromAPIWorker(worker) {
        return new this(
            worker.id,
            worker.name || '',
            worker.last_name || '',
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    lastName() {
        return this._lastName;
    }

    completeName() {
        return `${this.name()} ${this.lastName()}`;
    }

    assignCompany(company) {
        this._company = company;
    }

    hasCompany() {
        return !!this._company;
    }

    companyId() {
        return this._company.id();
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/model/PsWorker.js